import React from "react";
import { createRoot } from "react-dom/client";
import "../Styles/Toast.css";

export function showToast(message, duration = 3000, color) {
  // Create a container element for the toast
  const toastContainer = document.createElement("div");
  document.body.appendChild(toastContainer); // Append the toast to the DOM

  // Toast component definition
  const Toast = (
    <div className="toast" style={{ backgroundColor: color }}>
      <p style={{color: "white"}}>{message}</p>
    </div>
  );

  // Use React 18 createRoot API
  const root = createRoot(toastContainer);
  root.render(Toast);

  // Remove the toast after the specified duration
  setTimeout(() => {
    root.unmount(); // Unmount the component
    document.body.removeChild(toastContainer);
  }, duration);
}
